<template>
  <div class="drawer">
    <el-drawer
      size="850px"
      title="出库详情"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div style="line-height: 44px">
        <el-row
          style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="8">
            <span class="label">出库单号：</span>
            <span class="value">{{ detail.no }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">出库人：</span>
            <span class="value">{{ detail.outUser?detail.outUser.title:'--'  }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">出库日期：</span>
            <span class="value">
              {{ detail.outTime}}
            </span>
          </el-col>
        </el-row>
        <el-row
          style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="8">
            <span class="label">出库类型：</span>
            <span class="value">
              {{ detail.outOrderType && detail.outOrderType.title }}
            </span>
          </el-col>
          <el-col :span="8">
            <span class="label">去往门店：</span>
            <span class="value"> {{ detail.otherShopName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">调拨数量：</span>
            <span class="value"> {{ outCount }} </span>
          </el-col>
        </el-row>
        <el-row
          style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="24">
            <span class="label">调拨备注：</span>
            <span class="value">
              {{ detail.remark }}
            </span>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table
          ref="table"
          :data="tableData"
          row-class-name="row-expand-cove"
          style="max-height:600px;overflow-y: scroll;margin-left:30px;margin-top:10px;"
        >
          <el-table-column label="名称">
            <template slot-scope="props">
              {{ props.row.productName }}
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="props">
              {{ props.row.skuName }}
            </template>
          </el-table-column>
          <el-table-column label="单位" >
            <template slot-scope="props">
              <span>{{ props.row.outUnit }}</span>
            </template>
          </el-table-column>

          <el-table-column label="数量" width="60">
            <template slot-scope="props">
              <span>{{ props.row.outCount }}</span>
            </template>
          </el-table-column>

          <el-table-column label="条码" width="100">
            <template slot-scope="props">
              <span>{{ props.row.barCode }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="props">
              {{ props.row.remark }}
            </template>
          </el-table-column>


        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawerStatus: false,
      detail: {},
      outCount:0,
      tableData: [],
    };
  },
  props: {
    id: {
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getDetail();
    });
  },
  methods: {
    getType(goodscustom) {
      if (goodscustom.isCancel == 1) {
        return "warning";
      }
      if (goodscustom.acceptCount !== 0) {
        return "success";
      }
      if (goodscustom.acceptCount == 0) {
        return "info";
      }
    },
    handleClose() {
      this.$emit("submit");
    },
    // 提交
    getDetail() {
      let params = {
        id: this.id,
      };
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_Url66 + "api/out/info", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.detail = res.data;
            this.tableData=this.detail.orderItems;
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .label {
      display: inline-block;
      width: 100px;
      text-align: right;
      flex-shrink: 0;
      line-height: 24px;
    }
    .value {
      line-height: 24px;
    }
  }
}
</style>
